import { render, staticRenderFns } from "./teacherDetailPartner.vue?vue&type=template&id=6cea0c1a&scoped=true"
import script from "./teacherDetailPartner.vue?vue&type=script&lang=js"
export * from "./teacherDetailPartner.vue?vue&type=script&lang=js"
import style0 from "./teacherDetailPartner.vue?vue&type=style&index=0&id=6cea0c1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cea0c1a",
  null
  
)

export default component.exports